import { Base, usePointer } from '@studiometa/js-toolkit';

/**
 * ZoomedGallery - Fullscreen image modal with custom cursor
 */
export default class ZoomedGallery extends Base {
  static config = {
    name: 'ZoomedGallery',
    refs: ['img', 'loader'],
  };

  isOpen = false;

  /**
   * Calculate and apply translation based on Y position
   * @param {number} y Mouse Y position
   */
  updateImagePosition(y) {
    const img = this.$refs.img;
    const imgHeight = img.naturalHeight * (img.clientWidth / img.naturalWidth);
    const viewportHeight = window.innerHeight;
    const overflow = imgHeight - viewportHeight;

    if (overflow <= 0) return;

    const ratio = y / viewportHeight;
    const translateY = -overflow * ratio;
    img.style.transform = `translateY(${translateY}px)`;
  }

  /**
   * Open the gallery with the given image URL
   * @param {string} src
   * @param {string} alt
   */
  openGallery(src, alt = '') {
    // Show loader, hide image
    this.$refs.loader.classList.remove('hidden');
    this.$refs.img.classList.add('opacity-0');

    // Set image source
    this.$refs.img.src = src;
    this.$refs.img.alt = alt;

    // Wait for image to load
    this.$refs.img.addEventListener(
      'load',
      () => {
        this.$refs.loader.classList.add('hidden');
        this.$refs.img.classList.remove('opacity-0');
        // Apply initial position based on current cursor position
        const { y } = usePointer().props();
        this.updateImagePosition(y);
      },
      { once: true },
    );

    this.isOpen = true;
    this.$el.classList.remove('opacity-0', 'pointer-events-none');
    document.body.classList.add('overflow-hidden', 'is-zoomed');
    this.$emit('open');
  }

  /**
   * Handle mouse movement to pan the image vertically
   * @param {import('@studiometa/js-toolkit').PointerServiceProps} props
   */
  moved({ y }) {
    if (!this.isOpen) return;
    this.updateImagePosition(y);
  }

  /**
   * Close the gallery
   */
  closeGallery() {
    this.isOpen = false;
    this.$refs.img.style.transform = '';
    this.$el.classList.add('opacity-0', 'pointer-events-none');
    document.body.classList.remove('overflow-hidden', 'is-zoomed');
    this.$emit('close');
  }

  /**
   *
   */
  onClick() {
    this.closeGallery();
  }

  /**
   * @param {object} props
   * @param {boolean} props.ESC
   */
  keyed({ ESC }) {
    if (ESC) {
      this.closeGallery();
    }
  }
}
